module.exports = __webpack_public_path__ + "static/media/brand-story-meaning4.146b6417.png";